import { DicomTags } from "@minohealth/common/utils/dicom";
import { useViewerImage } from "../dicom-image-viewer";

/**
 * @param {Object} props
 * @param {ChatImage} props.srcImage
 */
export default function DicomViewer({ srcImage }) {
  const { dicomViewerUrl, fallbackUrl } = useViewerImage({
    studyInstanceUid: srcImage.metaData?.[DicomTags.STUDY_INSTANCE_UID]?.value,
    dicomUrls: [srcImage.resourceUrl].filter(Boolean),
    fallback: {
      url: srcImage.thumbnailUrl,
    },
  })

  if(dicomViewerUrl == null) {
    return <img src={fallbackUrl} />
  }

  return (
    // @ts-ignore - Using limited props on iframe to avoid type mismatches
    <iframe
      src={dicomViewerUrl}
      title="Dicom viewer"
    />
  );
}